import { Component } from '@angular/core';

@Component({
  selector: 'app-required-field-mark',
  standalone: true,
  template: `<span class="text-danger">*</span>`,
})
export class RequiredFieldMarkComponent {}
